module.exports = __webpack_public_path__ + "img/Spray.a192f46b.svg";